import type { ReactNode } from 'react';

import { HStack } from '../Core';

interface SummaryLineProps {
  title: ReactNode;
  value: ReactNode;
}

export const SummaryLine = ({ title, value, ...rest }: SummaryLineProps) => {
  return (
    <HStack justifyContent="space-between" {...rest}>
      {title}
      {value}
    </HStack>
  );
};
